import React from 'react';
import { site } from '../../configs/site';

// AWS funding band (site.funding). Shared by the home page and the
// platform pages.
const FundingBand = ({ className = 'px-4 pb-10 pt-4 sm:px-6 sm:pb-14 lg:px-10' }) => {
  if (!site.funding?.enabled) {
    return null;
  }

  return (
    <section className={className}>
      <div className="grid grid-cols-1 gap-6 rounded-xl bg-[#F3F0FB] p-7 ring-1 ring-inset ring-[#E4DCF7] md:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col gap-2">
          <div className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            {site.funding.eyebrow}
          </div>
          <h3 className="text-xl font-bold leading-snug text-gray-900">{site.funding.title}</h3>
          <p className="text-[13px] leading-normal text-gray-600">{site.funding.note}</p>
        </div>
        {site.funding.programs.map((program) => (
          <div key={program.title} className="flex flex-col gap-1.5">
            <div className="text-[15px] font-semibold text-gray-900">{program.title}</div>
            <div className="text-sm leading-normal text-gray-600">{program.description}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FundingBand;
